<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'online' && 'active'"
        @click.stop="handleClick('online')"
      >{{$t('apiDoc.在线文档')}}</span>
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'apiTest' && 'active'"
        @click.stop="handleClick('apiTest')"
      >{{$t('apiDoc.测试工具')}}</span>
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    <!-- 测试工具 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";

import apiTestDoc from "../components/apiTestDoc";

import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'
const apiUrlTest = 'order/printOrderUrl';
export default {
  components: { onlineDoc , apiTestDoc },
  data() { 
    return {
      mainStatus: "online",
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述
        apiDesc: `${this.$t('onlineDoc.OrderDescription_6')}`,
      //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
         //参数描述  START
       postDataList:[
            
        //   请求头参数
            {
                title:`${this.$t('onlineDoc.Headers')}`,
                value:[
                    {name: "apiAccount",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.接入方在平台的api账户标识')}`,},
                    {name: "digest",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.签名字符串')}`,},
                    {name: "timestamp",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.时间戳，毫秒')}`,},
                    { name: "digestType", type: "Number", require: "N", normal: "", describe: `${this.$t('onlineDoc.签名类型')}`, },
                    ]
            },
            { 
                title:`${this.$t('onlineDoc.请求参数')}`, 
                 value:[
                    {name: "bizContent",type: "String",require: "Y",normal: `${this.$t('onlineDoc.业务参数')}`,describe: `${this.$t('onlineDoc.业务参数模块内json格式的string类型')}`,},
                ]
            },
            {
              title:`${this.$t('onlineDoc.业务参数')}`,
              value:[
                {name: "customerCode",type: "String(30)",require: "Y",normal: "J0086024071",describe: `${this.$t('onlineDoc.客户编码（联系出货网点提供）')}`},
                {name: "digest",type: "String(50)",require: "Y",normal: `${this.$t('onlineDoc.明文密码:H5CD3zE6')}`,describe: `${this.$t('onlineDoc.signnew')}`},
                {name: "billCode", type: "String(30)", require: "Y", normal: "", describe: `${this.$t('onlineDoc.运单号')}`},
                {name: "needLogo", type: "String(30)", require: "N", normal: "0", describe: `${this.$t('onlineDoc.needLogo')}`},
                {name: "expressType", type: "String(30)", require: "N", normal: "0", describe: `${this.$t('onlineDoc.expressQueryType')}`},
                
              ]
            }
        ],
        //参数描述  END
        //报文描述 start
        responseDataList:[
            
        //   响应参数
            {
                title:`${this.$t('onlineDoc.响应参数')}`,
                value:[
                    { name: "code",type: "String", require: "Y",normal: "",describe: `${this.$t('onlineDoc.返回码，见附录')}`},
                    {name: "msg",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.描述')}`},
                    {name: "data",type: "Object",require: "Y",normal: "",describe: `${this.$t('onlineDoc.业务数据')}`},
                  ]
            },
            {
              title:`${this.$t('onlineDoc.data类型说明')}`,
              value:[
                  {name: "billCode",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.运单号')}`},
                  {name: "url",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.电子面单链接')}`}
                ]
            }

        ],
        //请求示例
        requestCode: `Header：
    apiAccount=292508153084379141
    digest=5EJcbtDRjOvSj+uGThytpA==
    timestamp=1638429847416

Body：
    bizContent= "{'customerCode': 'J0086024071', 'digest': '4hQ8qXNkuSJ8cIgJQDFFRA==', 'billCode': 'UTE010001093135'}"`,
        //返回示例
        responseCode: JSON.parse(
          `{"code":"1","msg":"success","data":"https://uat-jmssa-file.s3.me-south-1.amazonaws.com/yl-web-jmssa-openplatform-api/jmssa_openplatform_order_pdf/20220601/UTE300000392199.pdf?response-content-disposition=inline%3B%20filename%3DUTE300000392199.pdf&response-content-encoding=UTF-8&response-content-type=application%2Fpdf&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20220601T012424Z&X-Amz-SignedHeaders=host&X-Amz-Expires=604800&X-Amz-Credential=AKIAY3KSSVR4WGN3FJGS%2F20220601%2Fme-south-1%2Fs3%2Faws4_request&X-Amz-Signature=c20390b91deb6a61e01e0213b22d07862779b55c8ee9f27832355bc26b2d2233"}`
        ),

        
        //错误代码提示
        errcodeJson: [
          {code:'145003031',msg:`${this.$t('apiTestDoc.业务参数签名失败')}`},
          // {code:'145002002',msg:"运单重复,请勿使用相同运单号！"},
          {code:'145003042',msg:`${this.$t('apiTestDoc.修改订单失败')}`},
          // {code:'145003111',msg:"批次号无效！"},
        {code:'145003060',msg:`${this.$t('apiTestDoc.区域不合法')}`},
        {code:'145003061',msg:`${this.$t('apiTestDoc.城市不合法')}`},
        {code:'145003062',msg:`${this.$t('apiTestDoc.省份不合法')}`},
        {code:'145003064',msg:`${this.$t('apiTestDoc.查不到数据')}`},
        {code:'145003041',msg:`${this.$t('apiTestDoc.下单失败')}`},
        {code:'145003083',msg:`${this.$t('apiTestDoc.发件人信息不全')}`},
        // {code:'145003112',msg:"该批次号运单无效！"},
        {code:'145002001',msg:`${this.$t('apiTestDoc.订单重复,无需重复下单！')}`},
        {code:'145003084',msg:`${this.$t('apiTestDoc.收件人信息不全')}`},
        {code:'145003085',msg:`${this.$t('apiTestDoc.电话号码不能为空')}`},
        {code:'145003086',msg:`${this.$t('apiTestDoc.地址信息不全')}`},
        {code:'145003087',msg:`${this.$t('apiTestDoc.请检查订单类型、服务类型、派送类型、物品类型、快件类型、结算方式是否合法')}`},
        {code:'145003200',msg:`${this.$t('apiTestDoc.请检查服务类型是否合法值为 01或 02')}`},
        {code:'145003088',msg:`${this.$t('apiTestDoc.上门服务时间信息不全')}`},
        {code:'145003092',msg:`${this.$t('apiTestDoc.重量信息不合法')}`},
        {code:'145003093',msg:`${this.$t('apiTestDoc.物品信息不全')}`},
        {code:'145003094',msg:`${this.$t('apiTestDoc.物品名称不全')}`},
        {code:'145003095',msg:`${this.$t('apiTestDoc.物品类型不全')}`},
        // {code:'145003096',msg:"物品数量非法"},{code:'145003099',msg:"非法金额"},{code:'145003100',msg:"运单号非法"},
        {code:'145003101',msg:`${this.$t('apiTestDoc.客户订单号已存在,无法下单！')}`},
        {code:'145003103',msg:`${this.$t('apiTestDoc.姓名信息非法')}`},
        {code:'145003104',msg:`${this.$t('apiTestDoc.公司信息过长')}`},
        {code:'145003105',msg:`${this.$t('apiTestDoc.联系信息过长')}`},
        {code:'145003106',msg:`${this.$t('apiTestDoc.邮编或邮箱信息非法')}`},
        {code:'145003107',msg:`${this.$t('apiTestDoc.价格信息非法')}`},
        {code:'145003108',msg:`${this.$t('apiTestDoc.备注、描述、链接信息非法')}`},
        {code:'145003109',msg:`${this.$t('apiTestDoc.地址信息过长')}`},
        {code:'145003110',msg:`${this.$t('apiTestDoc.街道信息过长')}`},
        {code:'145003111',msg:`${this.$t('apiTestDoc.包裹总件数无效')}`},
        {code:'145003112',msg:`${this.$t('apiTestDoc.暂未开通代收货款业务')}`},
        {code:'145003113',msg:`${this.$t('apiTestDoc.支付方式不匹配,PP_CASH,CC_CASH,PP_MM')}`},
        {code:'145003201',msg:`${this.$t('apiTestDoc.已取件状态不可修改')}`},
        {code:'145003202',msg:`${this.$t('apiTestDoc.已取消状态不可修改')}`},
        {code:'145003203',msg:`${this.$t('apiTestDoc.更新订单失败，请稍后重试！')}`},
        {code:'145003083',msg:`${this.$t('apiTestDoc.始发地信息不全')}`},
        {code:'145003084',msg:`${this.$t('apiTestDoc.收货地信息不全')}`}]
      },

      apiTestData: {
          _headerData: {
            apiAccount: "1001",
            digest: "U40e5sumorgd3YgZzU61Mw==",
            timestamp: "1565238848921",
          },
          data:{
             bizContent: `{"customerCode":"J0086000020","digest":"/bGMxZbpzAtLrplAvEYvqw==","billCode": "UT0000273527404"}`
             },
        //必须要验证的参数
        requestData:['apiAccount','digest','timestamp','bizContent'],
        textareaData:{
          bizContent:true
        },
        //促发接口
        apiUrl: `/mock/${apiUrlTest}`,
        //返回
        ResponseJson: "",
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,
      
           
        //错误代码提示
        errcodeJson: [
          {code:'145003031',msg:`${this.$t('apiTestDoc.业务参数签名失败')}`},
          // {code:'145002002',msg:"运单重复,请勿使用相同运单号！"},{code:'145003042',msg:"修改订单失败"},
          // {code:'145003111',msg:"批次号无效！"},
        {code:'145003060',msg:`${this.$t('apiTestDoc.区域不合法')}`},
        {code:'145003061',msg:`${this.$t('apiTestDoc.城市不合法')}`},
        {code:'145003062',msg:`${this.$t('apiTestDoc.省份不合法')}`},
        {code:'145003064',msg:`${this.$t('apiTestDoc.查不到数据')}`},
        {code:'145003041',msg:`${this.$t('apiTestDoc.下单失败')}`},
        {code:'145003083',msg:`${this.$t('apiTestDoc.发件人信息不全')}`},
        // {code:'145003112',msg:"该批次号运单无效！"},
        {code:'145002001',msg:`${this.$t('apiTestDoc.订单重复,无需重复下单！')}`},
        {code:'145003084',msg:`${this.$t('apiTestDoc.收件人信息不全')}`},
        {code:'145003085',msg:`${this.$t('apiTestDoc.电话号码不能为空')}`},
        {code:'145003086',msg:`${this.$t('apiTestDoc.地址信息不全')}`},
        {code:'145003087',msg:`${this.$t('apiTestDoc.请检查订单类型、服务类型、派送类型、物品类型、快件类型、结算方式是否合法')}`},
        {code:'145003200',msg:`${this.$t('apiTestDoc.请检查服务类型是否合法值为 01或 02')}`},
        {code:'145003088',msg:`${this.$t('apiTestDoc.上门服务时间信息不全')}`},
        {code:'145003092',msg:`${this.$t('apiTestDoc.重量信息不合法')}`},
        {code:'145003093',msg:`${this.$t('apiTestDoc.物品类型不全')}`},
        {code:'145003096',msg:`${this.$t('apiTestDoc.物品数量非法')}`},
        {code:'145003099',msg:`${this.$t('apiTestDoc.非法金额')}`},
        // {code:'145003100',msg:"运单号非法"},
        {code:'145003101',msg:`${this.$t('apiTestDoc.客户订单号已存在,无法下单！')}`},
        {code:'145003103',msg:`${this.$t('apiTestDoc.姓名信息非法')}`},
        {code:'145003104',msg:`${this.$t('apiTestDoc.公司信息过长')}`},
        {code:'145003105',msg:`${this.$t('apiTestDoc.联系信息过长')}`},
        {code:'145003106',msg:`${this.$t('apiTestDoc.邮编或邮箱信息非法')}`},
        {code:'145003107',msg:`${this.$t('apiTestDoc.价格信息非法')}`},
        {code:'145003108',msg:`${this.$t('apiTestDoc.备注、描述、链接信息非法')}`},
        {code:'145003109',msg:`${this.$t('apiTestDoc.地址信息过长')}`},
        {code:'145003110',msg:`${this.$t('apiTestDoc.街道信息过长')}`},
        {code:'145003111',msg:`${this.$t('apiTestDoc.包裹总件数无效')}`},
        {code:'145003112',msg:`${this.$t('apiTestDoc.暂未开通代收货款业务')}`},
        {code:'145003113',msg:`${this.$t('apiTestDoc.支付方式不匹配,PP_CASH,CC_CASH,PP_MM')}`},
        {code:'145003201',msg:`${this.$t('apiTestDoc.已取件状态不可修改')}`},
        {code:'145003202',msg:`${this.$t('apiTestDoc.已取消状态不可修改')}`},
        {code:'145003203',msg:`${this.$t('apiTestDoc.更新订单失败，请稍后重试！')}`}]
      },
    };
  },
  created() {},
  methods: {
    handleClick(status) {
      this.mainStatus = status;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>